import React from "react";
import meetOurStaff from "../../PicesForPages/MeetOurStaff.png";
import YourTeamMembers from "../StaffDetails/teamMembers";

function MeetOurStaff() {
  return (
    <div className="purchaseParent ">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={meetOurStaff}
          alt="meetOurStaffImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          {/* <span>Meet Our Family</span> */}
        </div>
      </div>

      <YourTeamMembers />
    </div>
  );
}

export default MeetOurStaff;
